import { render, staticRenderFns } from "./CourseDashboardCard.vue?vue&type=template&id=00471532&scoped=true&"
import script from "./CourseDashboardCard.vue?vue&type=script&lang=js&"
export * from "./CourseDashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseDashboardCard.vue?vue&type=style&index=0&id=00471532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00471532",
  null
  
)

export default component.exports